import type {TFunction} from 'i18next';
import {getStatusLabel} from '@/components/common/forestMassStatusLabels';
import type {STATUS} from '@/domain/entities/ForestMassStatus';

export type StatusValueOption = {value: STATUS; label: string};

export const statusValueOptions = (statuses: Array<STATUS>, present: Set<STATUS>, t: TFunction): StatusValueOption[] =>
  statuses.filter((status) => present.has(status)).map((status) => ({value: status, label: getStatusLabel(status, t)}));
